export default __webpack_public_path__ + "static/media/15.ae3b4605.png";